<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="32.609" height="39.833" viewBox="0 0 32.609 39.833">
    <g id="cake" transform="translate(-42.56)">
      <g id="Сгруппировать_4806" data-name="Сгруппировать 4806" transform="translate(42.56)">
        <g id="Сгруппировать_4805" data-name="Сгруппировать 4805" transform="translate(0)">
          <path id="Контур_4057" data-name="Контур 4057" d="M195.514,10.864a3.623,3.623,0,0,0,3.105-5.486L195.514,0l-3.105,5.377a3.623,3.623,0,0,0,3.105,5.486Z" transform="translate(-179.219)" fill="#dbdfe6"/>
          <path id="Контур_4058" data-name="Контур 4058" d="M69.719,152.954H60.666v-3.621H57.045v3.621H47.992a5.436,5.436,0,0,0-5.432,5.432v2.788a3.546,3.546,0,0,0,6.056,2.508l3.875-3.866,3.866,3.857a3.631,3.631,0,0,0,5.015,0l3.875-3.857,3.866,3.857a3.546,3.546,0,0,0,6.056-2.508v-2.779A5.463,5.463,0,0,0,69.719,152.954Z" transform="translate(-42.56 -136.659)" fill="#dbdfe6"/>
          <path id="Контур_4059" data-name="Контур 4059" d="M67.175,320.026h0l-1.946-1.946-1.955,1.946a6.415,6.415,0,0,1-8.854,0l-1.946-1.946-1.955,1.946a6.139,6.139,0,0,1-4.409,1.838,6.251,6.251,0,0,1-3.549-1.114v8.356a1.816,1.816,0,0,0,1.811,1.811H73.34a1.816,1.816,0,0,0,1.811-1.811v-8.356a6.234,6.234,0,0,1-7.976-.724Z" transform="translate(-42.56 -291.084)" fill="#dbdfe6"/>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'IconCake',
  }
</script>
